module.exports = __webpack_public_path__ + "static/media/Restrictions_on_gatherings_delay.79404b40.svg";